import api from "../axios";
import { type Tariff } from "../types";

const getTariffByServiceType = async (serviceType: string) => {
  const response = await api.get<Tariff>(
    `/tariffs/by-service-type/${serviceType}`,
  );
  return response.data;
};

export const tariffsApi = {
  baseKey: ["tariffs"],

  getTariffByServiceTypeQueryOptions: (serviceType: string) => {
    const queryKey = [...tariffsApi.baseKey, "by-service-type", serviceType];

    return {
      queryKey,
      queryFn: () => getTariffByServiceType(serviceType),
    };
  },
};
